import { render, staticRenderFns } from "./olimpo.vue?vue&type=template&id=2f893779&lang=html&"
import script from "./olimpo.vue?vue&type=script&lang=js&"
export * from "./olimpo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports